import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BusinessFuel } from '../models/business-fuel.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FuelService } from '../services/fuel.service';
var EditFuelComponent = /** @class */ (function () {
    function EditFuelComponent(_matDialogRef, data, _fuelService) {
        this._matDialogRef = _matDialogRef;
        this._fuelService = _fuelService;
        this.isNew = false;
        this.isLoading = false;
        this.fuel = data.fuel || new BusinessFuel();
        this.isNew = data.isNew || false;
        if (this.isNew) {
            this.fuel.otherInfo = '';
        }
        this.businessID = data.busID;
        this.originalFuel = Object.assign(new BusinessFuel(), data.fuel);
        this.itemsToChange = new Set();
        this.selectedType = this.fuel.fuelType || '';
        this.selectedBrand = this.fuel.fuelBrand || '';
        this.selectedService = BusinessFuel.formatServiceType(this.fuel.service);
        this.selectedPrice = this.fuel.price ? this.fuel.price.toFixed(2) : '';
    }
    EditFuelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            type: new FormControl(this.selectedType, [Validators.required]),
            brand: new FormControl(this.selectedBrand, [Validators.required]),
            fee: new FormControl(this.selectedPrice, [Validators.required, Validators.maxLength(6),
                Validators.pattern('\\d+\\.\\d\\d')]),
            service: new FormControl(this.selectedService, [Validators.required]),
            note: new FormControl(this.fuel.otherInfo, [Validators.maxLength(50)])
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditFuelComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.fuel.fuelType = this.formGroup.get('type').value;
                        this.fuel.fuelBrand = this.formGroup.get('brand').value;
                        this.fuel.service = this.formGroup.get('service').value;
                        this.fuel.otherInfo = this.formGroup.get('note').value;
                        this.fuel.price = this.formGroup.get('fee').value;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._fuelService.postBusinessFuel(this.businessID, this.fuel)];
                    case 1:
                        res = _a.sent();
                        this.fuel = BusinessFuel.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._fuelService.putBusinessFuel(this.businessID, this.fuel)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.fuel, BusinessFuel.parse(res));
                        this.fuel = BusinessFuel.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, contact: this.fuel });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditFuelComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditFuelComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.fuel, this.originalFuel);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditFuelComponent;
}());
export { EditFuelComponent };
